"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;

var _styledComponents = require("styled-components");

var _ = require(".");

var _jsxRuntime = require("react/jsx-runtime");

var Badge = function Badge(_ref) {
  var type = _ref.type,
      children = _ref.children;
  var theme = (0, _styledComponents.useTheme)();
  return (0, _jsxRuntime.jsx)(_.Box, {
    backgroundColor: theme.variants.banner[type].color,
    sx: {
      borderRadius: 'banner'
    },
    children: (0, _jsxRuntime.jsx)(_.Body, {
      fontSize: "1",
      fontWeight: "bold",
      color: "white",
      sx: {
        textTransform: 'uppercase'
      },
      px: "6px",
      children: children
    })
  });
};

exports.Badge = Badge;